import InternalAPI from "../../../../../app/axios"

export default class ElectronicDeliveryOrderRepository extends InternalAPI{
    constructor() {
        super();
        /** @type {string} */
        this.endpoint = "/v1/middleware/e-do"
    }

      /**
     *
     * @param param {string}
     * @return {Promise<{data: EDO[], err: null}|{data: null, err: ErrorState}>}
     */
       async getAll(param) {

        try {
            /** @type {AxiosResponse<Array<Object>>} */
            const res = await this.$axiosMiddleware.get(this.endpoint + "/stts?"+param);
            if (res.status === 200) {
                if (res.data) {
                    return {data: res.data.data, err: null}
                }
            }
            return {data: null, err: null}
        } catch (err) {
            return {data: null, err: this.setErrorMessage(err.response)}
        }
    }
}